<footer class="footer mt-auto py-3">
  <div class="container text-center">
    <p>
      Développé avec Svelte par <a href="mailto:senes.caroline@orange.fr"
        >Caroline SENES</a
      >
      et conforme aux normes du <a href="https://www.w3.org/Status">W3C</a>.
    </p>
  </div>
</footer>

